module["exports"] = [];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ru/name/prefix.js
 ** module id = 915
 ** module chunks = 0
 **/